module.exports = __webpack_public_path__ + "media/images/about-us/Headshots/Andy Piggott-c7d8404b96df200c5cfaf701ce0a502e.png";